<template>
  <div class="row">
    <div class="col-xs-12">
      <button type="button" class="btn btn-primary btn-voltar" @click="$router.back()">
        <font-awesome-icon :icon="'arrow-left'"/>
        Voltar
      </button>
      <h1 class="page-header">{{ type }} {{ title }}</h1>
      <div class="row">
        <div class="col-xs-12">
          <div class="col-xs-12" style="min-height:95px">
            <div :class="['form-group', { 'has-error': errors.has('nome') }]">
              <label
                :class="[
                  'control-label',
                  'custom-font',
                  { 'is-danger': errors.has('nome') }
                ]"
                >Nome</label
              >
              <div class="inputgroupcontainer">
                <div class="input-group">
                  <span class="input-group-addon">
                    <font-awesome-icon
                      :icon="'id-card'"
                      :class="[{ 'is-danger': errors.has('nome') }]"
                    ></font-awesome-icon>
                  </span>
                  <input
                    ref="nome"
                    v-model="model.nome"
                    name="nome"
                    placeholder="Nome"
                    class="form-control"
                    v-validate="'required'"
                    maxlength="255"
                    type="text"
                  />
                  <div
                    :class="[
                      'input-group-addon custom-input-group-addon-count',
                      { 'is-danger': errors.has('nome') }
                    ]"
                    v-text="255 - model.nome.length"
                  ></div>
                </div>
                <small
                  v-if="errors.has('nome')"
                  data-bv-validator="notempty"
                  data-bv-validator-for="nome"
                  class="help-block"
                  style=""
                  ><font-awesome-icon :icon="'exclamation-triangle'" />
                  Preenchimento obrigatório!
                </small>
              </div>
            </div>
          </div>
          <div class="col-xs-12" style="min-height:95px">
            <div
              :class="['form-group', { 'has-error': errors.has('descricao') }]"
            >
              <label
                :class="[
                  'control-label',
                  'custom-font',
                  { 'is-danger': errors.has('descricao') }
                ]"
                >Descrição</label
              >
              <div class="inputgroupcontainer">
                <div class="input-group">
                  <span class="input-group-addon">
                    <font-awesome-icon
                      :icon="'tags'"
                      :class="[{ 'is-danger': errors.has('descricao') }]"
                    ></font-awesome-icon>
                  </span>
                  <textarea
                    ref="descricao"
                    rows="3"
                    name="descricao"
                    v-model="model.descricao"
                    placeholder="Descrição"
                    class="form-control"
                    maxlength="255"
                    v-validate="'required'"
                  >
                  </textarea>
                  <div
                    :class="[
                      'input-group-addon custom-input-group-addon-count',
                      { 'is-danger': errors.has('descricao') }
                    ]"
                    v-text="255 - model.descricao.length"
                  ></div>
                </div>
                <small
                  v-if="errors.has('descricao')"
                  data-bv-validator="notempty"
                  data-bv-validator-for="descricao"
                  class="help-block"
                  style=""
                  ><font-awesome-icon :icon="'exclamation-triangle'" />
                  Preenchimento obrigatório!</small
                >
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <div :class="['form-group', { 'has-error': errors.has('fonte') }]">
              <label
                :class="[
                  'control-label',
                  'custom-font',
                  { 'is-danger': errors.has('fonte') }
                ]"
                >Fonte</label
              >
              <div class="inputgroupcontainer">
                <div class="input-group">
                  <span class="input-group-addon">
                    <font-awesome-icon
                      :icon="'envelope'"
                      :class="[{ 'is-danger': errors.has('fonte') }]"
                    ></font-awesome-icon>
                  </span>
                  <input
                    ref="fonte"
                    name="fonte"
                    v-model="model.fonte"
                    placeholder="Fonte"
                    class="form-control"
                    v-validate="'required'"
                    maxlength="255"
                    type="text"
                  />
                  <div
                    :class="[
                      'input-group-addon custom-input-group-addon-count',
                      { 'is-danger': errors.has('fonte') }
                    ]"
                    v-text="255 - model.fonte.length"
                  ></div>
                </div>
                <small
                  v-if="errors.has('fonte')"
                  data-bv-validator="notempty"
                  data-bv-validator-for="fonte"
                  class="help-block"
                  style=""
                  ><font-awesome-icon :icon="'exclamation-triangle'" />
                  Preenchimento obrigatório!</small
                >
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-3">
            <div
              :class="[
                'form-group',
                { 'has-error': errors.has('periodicidade') }
              ]"
            >
              <label class="control-label custom-font">Periodicidade</label>
              <div class="custom-select">
                <select
                  ref="periodicidade"
                  class="form-control select-selected"
                  name="periodicidade"
                  v-model="model.periodicidade"
                  v-validate="'required'"
                >
                  <option
                    v-for="p in lista.periodicidades"
                    :key="p.codigo"
                    :value="p.codigo"
                  >
                    {{ p.descricao }}
                  </option>
                </select>
              </div>
              <small
                v-if="errors.has('periodicidade')"
                data-bv-validator="notempty"
                data-bv-validator-for="periodicidade"
                class="help-block"
                style=""
                ><font-awesome-icon :icon="'exclamation-triangle'" />
                Preenchimento obrigatório!</small
              >
            </div>
          </div>
          <div class="col-xs-12 col-sm-3">
            <div class="form-group">
              <label class="custom-font">Tipo de valor do dado</label>
              <div class="radio">
                <label class="custom-check-label">
                  <input
                    type="radio"
                    v-model="model.tipoValor"
                    name="tipovalor"
                    value="I"
                    checked=""
                  />
                  Número inteiro
                </label>
              </div>
              <div class="radio">
                <label class="custom-check-label">
                  <input
                    type="radio"
                    v-model="model.tipoValor"
                    name="tipovalor"
                    value="D"
                  />
                  Número decimal
                </label>
              </div>
              <div class="radio">
                <label class="custom-check-label">
                  <input
                    type="radio"
                    v-model="model.tipoValor"
                    name="tipovalor"
                    value="T"
                  />
                  Texto
                </label>
              </div>
            </div>
          </div>
          <div class="form-group col-xs-12">
            <label class="control-label custom-font">Tags</label>
            <div class="list-group">
              <a
                v-for="t in lista.tags"
                href="javascript:void  (0)"
                :key="t.codigo"
                @click.prevent="toogleshow(t)"
                :class="[
                  'list-group-item col-md-3 custom-meta',
                  { 'item-selected': t.selected }
                ]"
              >
                <font-awesome-icon :icon="'tags'"></font-awesome-icon>
                <span class="text-muted">
                  {{ t.descricao }}
                </span>
              </a>
            </div>
          </div>
          <div class="form-group col-xs-12">
            <label class="control-label custom-font">Secretarias</label>
            <div class="list-group">
              <a
                v-for="s in lista.secretarias"
                href="javascript:void  (0)"
                :key="s.codigo"
                @click.prevent="toogleshow(s)"
                :class="[
                  'list-group-item col-md-2 custom-meta',
                  { 'item-selected': s.selected }
                ]"
              >
                <font-awesome-icon :icon="'monument'"></font-awesome-icon>
                <span class="text-muted">
                  {{ s.sigla }}
                </span>
              </a>
            </div>
          </div>
          <div class="form-group col-xs-12">
            <label class="control-label custom-font">Autarquias</label>
            <div class="list-group">
              <a
                v-for="a in lista.autarquias"
                href="javascript:void  (0)"
                :key="a.codigo"
                @click.prevent="toogleshow(a)"
                :class="[
                  'list-group-item col-md-3 custom-meta',
                  { 'item-selected': a.selected }
                ]"
              >
                <font-awesome-icon :icon="'monument'"></font-awesome-icon>
                <span class="text-muted">
                  {{ a.sigla }}
                </span>
              </a>
            </div>
          </div>
          <div class="form-group col-xs-12">
            <label class="control-label custom-font">Eixos</label>
            <div class="list-group">
              <a
                v-for="i in lista.eixos"
                href="javascript:void  (0)"
                :key="i.id"
                @click.prevent="toogleshow(i)"
                :class="[
                  'list-group-item col-md-6 custom-meta',
                  { 'item-selected': i.selected }
                ]"
              >
                <font-awesome-icon :icon="'monument'"></font-awesome-icon>
                <span class="text-muted">
                  {{ i.descricao }}
                </span>
              </a>
            </div>
          </div>
          <div class="form-group col-xs-12">
            <label class="control-label custom-font">Metas</label>
            <div class="list-group">
              <a
                v-for="i in lista.metas"
                href="javascript:void  (0)"
                :key="i.codigo"
                @click.prevent="toogleshow(i)"
                :class="[
                  'pad10 list-group-item col-md-2 custom-meta',
                  { 'item-selected': i.selected }
                ]"
                style="padding:10px;text-align:center"
              >
                <img
                  :alt="i.titulo"
                  style="max-width:129px;max-height:129px"
                  :src="concatPathImage(i.imagem_url)"
                />
              </a>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <label class="control-label custom-font">Usuários</label>
              <autocomplete
                id="usuario"
                name="usuario"
                classNameInput="form-control"
                placeholder="Localizar usuários"
                urlsource="user/list/all"
                propsource="data"
                item_key="codigo"
                item_text="username"
                :onSetData="selecionarUsuario"
              >
              </autocomplete>
            </div>
          </div>
          <div class="form-group col-xs-12">
            <label class="control-label custom-font"
              >Usuários com permissão para registrar valores</label
            >
            <div class="list-group well" style="overflow:auto">
              <div
                v-for="(u, index) in lista.usuarios"
                href="javascript:void(0)"
                :key="u.id"
                @click.prevent="toogleshow(u)"
                class="list-group-item col-md-4"
              >
                <font-awesome-icon :icon="'user'"></font-awesome-icon>
                {{ u.username }} <br />
                <span class="text-muted small">
                  <em>{{ u.email }}</em>
                </span>
                <button
                  type="button"
                  style="margin-top:-10px;"
                  class="close"
                  @click.prevent="removerUsuario(index)"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>
            </div>
          </div>
          <!-- Button -->
          <div class="form-group col-xs-12" style="margin-top:30px">
            <button
              @click.prevent="salvar()"
              class="btn btn-default"
              :disabled="carregando"
            >
              <font-awesome-icon v-if="carregando" :icon="'spinner'" spin />
              <font-awesome-icon v-else :icon="'save'" />
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}

.custom-check-label {
  color: #00615c;
}

.custom-meta {
  color: #00615c;
}

.custom-select {
  border: 1px solid;
  border-radius: 4px;
  border-color: #00615c;
}

.select-selected {
  background-color: #eeeeee;
  color: #00615c;
}

.custom-input-group-addon-count {
  color: #00615c;
}

.fa-tags {
  color: #00615c;
}

.fa-id-card {
  color: #00615c;
}

.fa-edit {
  color: #00615c;
}

.fa-envelope {
  color: #00615c;
}

.fa-user {
  color: #00615c;
}

.custom-font.is-danger {
  color: #990000;
}

.custom-input-group-addon-count.is-danger {
  color: #990000;
}

.fa-tags.is-danger {
  color: #990000;
}

.fa-id-card.is-danger {
  color: #990000;
}

.fa-edit.is-danger {
  color: #990000;
}

.fa-envelope.is-danger {
  color: #990000;
}

.btn-voltar {
  margin-top: 20px;
}
</style>

<script>
import { request } from '@/request'
import autocomplete from '@/components/common/AutoComplete'

export default {
  name: 'dado-save',
  components: { autocomplete },
  data() {
    return {
      type: 'Adicionar',
      title: 'dados',
      carregando: false,
      model: {
        nome: '',
        descricao: '',
        fonte: '',
        tipoValor: 'I',
        periodicidade: 1,
        usuarios: []
      },
      lista: {
        tags: [],
        secretarias: [],
        autarquias: [],
        eixos: [],
        metas: [],
        usuarios: [],
        periodicidades: []
      }
    }
  },
  beforecreate() {
    if (!this.$store.state.islogged) {
      this.$router.push('/login')
    }
  },
  mounted() {
    var parametrosRecebido = this.$router.history.current.params
    var ehAtualizacao = parametrosRecebido.hasOwnProperty('id')

    if (ehAtualizacao) {
      request
        .get(`dado/get/${parametrosRecebido.id}`)
        .then(({ data }) => {
          const { periodicidade } = data

          if (data) {
            this.model = data
            this.model.periodicidade = periodicidade.codigo
            this.carregarListas(ehAtualizacao)

            if (ehAtualizacao) {
              this.type = 'Editar'
              this.listaAdicionarItens('usuarios', this.model.usuarios)
              this.listaSelecionarItens('usuarios', 'codigo')
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(response => {})
    } else {
      this.carregarListas(ehAtualizacao)
      this.$refs.nome.focus()
    }

    this.$refs.nome.focus()
  },
  computed: {
    listaErros() {
      let listasStatus = {}
      let tipos = ['tags', 'secretarias', 'eixos', 'metas']
      let status = false
      let primeiro = ''

      tipos.forEach(tipo => {
        listasStatus[tipo] = this.listaNaoHaItemSelecionado(tipo)
        if (!status) status = listasStatus[tipo]
        if (listasStatus[tipo] && primeiro.length === 0) primeiro = tipo
      })

      return Object.assign({ status, primeiro }, listasStatus)
    },
    parametroDado() {
      let dado = Object.assign({}, this.model)

      let selecionados = i => {
        return i.selected
      }
      let codigos = i => {
        return i.codigo
      }

      Object.keys(this.lista).forEach(listaKey => {
        if (listaKey === 'secretarias' || listaKey === 'autarquias') {
          dado[listaKey] = this.lista[listaKey].filter(selecionados)
        } else {
          dado[listaKey] = this.lista[listaKey]
            .filter(selecionados)
            .map(codigos)
        }
      })

      delete dado.periodicidades

      return dado
    }
  },
  methods: {
    toogleshow(e) {
      e.selected = !e.selected
    },
    carregarListas(selecionaItens) {
      this.carregarLista('listar-tags', 'tags', 'codigo', selecionaItens)
      this.carregarLista('listar-secretarias', 'secretarias', 'sigla', selecionaItens)
      this.carregarLista('listar-autarquias', 'autarquias', 'sigla', selecionaItens)
      this.carregarLista('listar-eixos', 'eixos', 'codigo', selecionaItens)
      this.carregarLista('listar-metas', 'metas', 'codigo', selecionaItens)
      this.carregarLista('listar-periodicidades', 'periodicidades', 'codigo', selecionaItens)
    },
    carregarLista(url, listaKey, itemKey, selecionaItens) {
      request
        .get(url)
        .then(r => {
          if (r.data.data.length === 0) return
          this.listaAdicionarItens(listaKey, r.data.data)
          if (selecionaItens) this.listaSelecionarItens(listaKey, itemKey)
        })
        .catch(r => {
          console.log(r.response)
        })
    },
    listaAdicionarItens(key, valores, callback) {
      if (!this.lista.hasOwnProperty(key)) return
      this.lista[key] = valores.map(i => {
        i.selected = false
        return i
      })
      if (callback) callback()
    },
    listaSelecionarItens(listaKey, itemKey) {
      if (
        !this.lista.hasOwnProperty(listaKey) ||
        !this.model.hasOwnProperty(listaKey)
      )
        return

      let itensSelecionados = this.model[listaKey].map(item => {
        return item[itemKey]
      })

      this.lista[listaKey].forEach(item => {
        item.selected = itensSelecionados.indexOf(item[itemKey]) > -1
      })

      this.$forceUpdate()
    },
    saveSuccess(result) {
      this.$toastr.s('Dado foi salvo com sucesso.')
      this.$router.push({ name: 'dados_list' })
    },
    saveFail(result) {
      this.$toastr.e(
        'Houve uma falha ao tentar salvar este item, Tente novamente daqui alguns minutos!'
      )
    },
    salvar() {
      var me = this
      this.$validator.validateAll().then(result => {
        if (!result) {
          me.$refs[this.$validator.errors.items[0].field].focus()
          me.$toastr.e(this.$validator.errors.items[0].msg)
          return
        }

        request
          .post(`dado/save`, this.parametroDado)
          .then(this.saveSuccess)
          .catch(this.saveFail)
      })
    },
    listaNotificacaoErro() {
      this.$toastr.e('Selecione uma ou mais ' + this.listaErros.primeiro + '!')
    },
    listaNaoHaItemSelecionado(listaKey) {
      return (
        this.lista[listaKey].filter(i => {
          return i.selected === true
        }).length === 0
      )
    },
    selecionarUsuario(u) {
      if (this.usuarioSelecionado(u)) return
      u.index = this.lista.usuarios.length
      u.selected = true
      this.lista.usuarios.push(u)
    },
    usuarioSelecionado(u) {
      return !!this.lista.usuarios.find(i => i.codigo === u.codigo)
    },
    removerUsuario(index) {
      this.lista.usuarios.splice(index, 1)
    },
    concatPathImage(file) {
      return this.$root.$data.imgUrl + file + '?' + new Date().getTime()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/dados/Save.vue